import React, { useState } from "react";
import { InputText } from "primereact/inputtext";

export default function InputTextTelefone(props) {
  const [value, setValue] = useState(props.value || "");

  const formatTelefone = (input) => {
    const numbers = input.replace(/\D/g, ""); // Remove tudo que não for número

    if (numbers.length < 2) return numbers; // Evita formatar DDD incompleto

    if (numbers.length <= 10) {
      return numbers.replace(/^(\d{2})(\d{4})(\d{0,4})$/, "($1) $2-$3");
    } else {
      return numbers.replace(/^(\d{2})(\d{5})(\d{0,4})$/, "($1) $2-$3");
    }
  };

  const handleChange = (event) => {
    const rawValue = event.target.value.replace(/\D/g, ""); // Remove caracteres não numéricos
    const formatted = formatTelefone(rawValue);

    setValue(formatted);

    // Verifica se a função `onChange` foi passada corretamente pelos props
    if (props.onChange) {
      props.onChange({
        ...event,
        target: { 
          ...event.target, 
          name : props.name,
          value: formatted },
      });
    }
  };

  return (
    <InputText
      {...props}
      value={value}
      onChange={handleChange}
      placeholder="(XX) XXXXX-XXXX"
      maxLength="15"
    />
  );
}
